import { Box, Button } from '@mui/material';

const tabIconMap = {
    'Início': {
        inactive: '/assets/logos-svg/homeBlack.svg',
        active: '/assets/logos-svg/homeRed.svg'
    },
    Agendamentos: {
        inactive: '/assets/logos-svg/agendaBlack.svg',
        active: '/assets/logos-svg/agendaRed.svg'
    },
    'Equipa Técnica': {
        inactive: '/assets/logos-svg/doctorsBlack.svg',
        active: '/assets/logos-svg/doctorsRed.svg'
    },
    'Cuidadores e Pacientes': {
        inactive: '/assets/logos-svg/caregiverBlack.svg',
        active: '/assets/logos-svg/caregiverRed.svg'
    },
    Documentos: {
        inactive: '/assets/logos-svg/docsBlack.svg',
        active: '/assets/logos-svg/docsRed.svg'
    }
};

const DashboardTabs = ({ tabs, onTabClick, activeTab }) => {
    return (
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: {
                    xs: '1fr',
                    md: `repeat(${tabs.length}, minmax(160px, 1fr))`
                },
                gap: { xs: 1.2, md: 1.6 },
                px: { xs: 1.8, md: 2.8 },
                py: { xs: 1.8, md: 2.4 }
            }}
        >
            {tabs.map((tab) => {
                const isActive = activeTab === tab;
                const iconConfig = tabIconMap[tab];
                const iconSrc = iconConfig ? (isActive ? iconConfig.active : iconConfig.inactive) : null;

                return (
                    <Button
                        key={tab}
                        variant="outlined"
                        onClick={() => onTabClick?.(tab)}
                        sx={{
                            justifyContent: 'flex-start',
                            gap: 1.2,
                            minHeight: 64,
                            px: 2.6,
                            py: 1.7,
                            textTransform: 'none',
                            fontSize: '0.95rem',
                            fontWeight: 700,
                            color: isActive ? '#D63731' : '#3D3D3D',
                            borderColor: isActive ? '#D63731' : '#D9D9D9',
                            borderWidth: isActive ? '2.5px' : '2px',
                            bgcolor: isActive ? 'rgba(214, 55, 49, 0.05)' : '#FFFFFF',
                            borderRadius: '18px',
                            '&:hover': {
                                bgcolor: isActive ? 'rgba(214, 55, 49, 0.05)' : '#F7F7F7',
                                borderColor: isActive ? '#D63731' : '#CFCFCF',
                                borderWidth: isActive ? '2.5px' : '2px'
                            }
                        }}
                    >
                        {iconSrc ? (
                            <Box
                                component="img"
                                src={iconSrc}
                                alt=""
                                sx={{
                                    width: 21,
                                    height: 21,
                                    display: 'block',
                                    flexShrink: 0,
                                    filter: 'none'
                                }}
                            />
                        ) : null}
                        {tab}
                    </Button>
                );
            })}
        </Box>
    );
};

export default DashboardTabs;
